import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './utils/ScrollToTop'
import Step1 from './components/Steps/Step1';
import Step2 from './components/Steps/Step2';
import Step3 from './components/Steps/Step3';
import Step4 from './components/Steps/Step4';
import Step5 from './components/Steps/Step5';
import Step6 from './components/Steps/Step6';
import Step7 from './components/Steps/Step7';
import Step8 from './components/Steps/Step8';
import Step9 from './components/Steps/Step9';
import Step10 from './components/Steps/Step10';
import Step11 from './components/Steps/Step11';
import Step12 from './components/Steps/Step12';
import Step13 from './components/Steps/Step13';
import Step14 from './components/Steps/Step14';
import Step15 from './components/Steps/Step15';
import Step16 from './components/Steps/Step16';
import Step17 from './components/Steps/Step17';
import Step18 from './components/Steps/Step18';
import Step19 from './components/Steps/Step19';
import Step20 from './components/Steps/Step20';
import ResultsTable from './components/ResultsTable/ResultsTable';
// import Dashboard from './pages/admin/Dashboard';

import store from './utils/store'

import './index.css';

store.init()

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop />
    <Switch>
      <Route path="/" component={App} exact={true} />
      <Route path="/step1" component={Step1} exact={true} />
      <Route path="/step2" component={Step2} exact={true} />
      <Route path="/step3" component={Step3} exact={true} />
      <Route path="/step4" component={Step4} exact={true} />
      <Route path="/step5" component={Step5} exact={true} />
      <Route path="/step6" component={Step6} exact={true} />
      <Route path="/step7" component={Step7} exact={true} />
      <Route path="/step8" component={Step8} exact={true} />
      <Route path="/step9" component={Step9} exact={true} />
      <Route path="/step10" component={Step10} exact={true} />
      <Route path="/step11" component={Step11} exact={true} />
      <Route path="/step12" component={Step12} exact={true} />
      <Route path="/step13" component={Step13} exact={true} />
      <Route path="/step14" component={Step14} exact={true} />
      <Route path="/step15" component={Step15} exact={true} />
      <Route path="/step16" component={Step16} exact={true} />
      <Route path="/step17" component={Step17} exact={true} />
      <Route path="/step18" component={Step18} exact={true} />
      <Route path="/step19" component={Step19} exact={true} />
      <Route path="/step20" component={Step20} exact={true} />
      <Route path="/ResultsTable" component={ResultsTable} exact={true} />
      <Route path="/home" render={() => <Redirect to="/" />} />
      {/* <Route path="/admin" component={Dashboard} exact={true} /> */}
      <Route path="/*" render={() => <Redirect to="/" />} />
    </Switch>
  </BrowserRouter>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
